import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getDatabase, ref, get, set, onValue } from 'firebase/database';
import ImageWidget from '../WidgetTypes/ImageWidget';
import '../PagePublic.css'
import MethodologyWidget from '../WidgetTypes/MethodologyWidget';
import PersonalBrandingWidget from '../WidgetTypes/PersonalBrandingWidget';


function DemoPagePublic() {
  const { customRoute } = useParams(); // Verwenden von customRoute statt pageId
  const [pageData, setPageData] = useState(null);
  const db = getDatabase();
  const [loading, setLoading] = useState(true);
  const [translateWidgetLoaded, setTranslateWidgetLoaded] = useState(false);

  useEffect(() => {
    // Abrufen der pageId und userId basierend auf der customRoute
    const publicPageRef = ref(db, `/demoPublicPages/${customRoute}`);
    get(publicPageRef).then((snapshot) => {
      if (snapshot.exists()) {
        const { pageId, userId } = snapshot.val();


        // Laden der Seitendaten
        const pageRef = ref(db, `/demoPages/${userId}/${pageId}`);
        onValue(pageRef, (pageSnapshot) => {
          const data = pageSnapshot.val();
          setPageData(data);
          setLoading(false);
          setTranslateWidgetLoaded(true); // Setzen Sie dies auf true, sobald die Widgets geladen sind

        });
      } else {
        setLoading(false);
      }
    });
  }, [db, customRoute]);

  const imageUrl = pageData && pageData.livePageImg ? pageData.livePageImg : "/img/BonusClub_Logo.webp";


  if (loading) {
    return <div className="loading">
      <div className="spinner3" id="spinnerle" >
        
      </div></div>; // Spinner anstelle des "Loading..." Textes
}


  if (!pageData || !pageData.widgets) {
    return <div>Seite nicht gefunden.</div>;
  }

  const renderWidget = (widget) => {
    switch (widget.type) {
                           case 'MethodologyWidget':
                             return <MethodologyWidget data={widget} isEditMode={false} />;
                           case 'PersonalBrandingWidget':
                             return <PersonalBrandingWidget data={widget} isEditMode={false} />;
                      
                
                
                          default:
        return <div>Unknown Widget</div>;
    }
  };

  const pageBackgroundColor = pageData?.backgroundColor || '#FFFFFF'; // Standardfarbe Weiß, wenn keine Hintergrundfarbe angegeben ist


  return (
    <div className="page_public">
        <div className="page_public_widgets_wrapper" style={{ backgroundColor: pageBackgroundColor }}>
      {pageData.widgets.map((widget, index) => (
        <div key={index} className="widget-boss-wrapper" style={{ backgroundColor: pageBackgroundColor }} >
          {renderWidget(widget)}
        </div>
      ))}
    </div>
    <img src={imageUrl} alt="Seitenbild" />
    </div>


  );
}

export default DemoPagePublic;
